const impactBrandKitPermissions = (action, permissions, institutionId) => {
  if (
    action === 'impactBrandKit:access' &&
    institutionId in permissions &&
    permissions[institutionId].includes('IMPACT_BRAND_KIT')
  ) {
    return true;
  }

  return false;
};

module.exports = {
  impactBrandKitPermissions,
};
